var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    ("" + _vm.classPrefix),
    _vm.computedSize && (_vm.classPrefix + "--" + _vm.computedSize),
    {
        'is-disabled': _vm.isDisabled,
        'is-checked': _vm.model === _vm.label,
    }
]},[_c('span',{class:[(_vm.classPrefix + "__input")]},[_c('span',{class:[(_vm.classPrefix + "__inner")]}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],class:[(_vm.classPrefix + "__source")],attrs:{"type":"radio","name":_vm.name,"hidden":"","disabled":_vm.isDisabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":[function($event){_vm.model=_vm.label},_vm.handleChange]}})]),_c('span',{class:[(_vm.classPrefix + "__label")]},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }